// src/i18n.ts (ou .js)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nextHttpBackend from 'i18next-http-backend';
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

i18n
    // Utilise http-backend pour charger les fichiers JSON
    .use(i18nextHttpBackend)
    // (Optionnel) Détecte la langue du navigateur
    .use(i18nextBrowserLanguageDetector)
    // Permet l'intégration à react-i18next
    .use(initReactI18next)
    .init({
        // Où sont stockés vos JSON ?
        // par défaut, i18next-http-backend va chercher: /locales/{{lng}}/{{ns}}.json
        // si vous avez mis "public/locales", ça devrait marcher directement.

        backend: {
            // Cache-busting : la version de build (injectée par Vite, cf. vite.config.ts)
            // est ajoutée en query string. Chaque déploiement change la version → le
            // navigateur re-télécharge les traductions au lieu de servir l'ancien cache.
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__APP_BUILD_VERSION__}`
        },

        // langues supportées (admin = fr/en, autres = pages publiques)
        supportedLngs: ['en', 'fr', 'es', 'de', 'it', 'ru'],
        // namespace(s) disponibles
        ns: ['global', 'survey', 'locks', 'modules', 'checkin', 'payment', 'common', 'navigation', 'settings', 'dashboard', 'cardex', 'companies', 'hotelEvents', 'reservations', 'segments', 'loyalty', 'housekeeping', 'messaging', 'customer-space', 'flows', 'email-templates', 'auth', 'reviews', 'payments', 'products', 'booking-request-public', 'support', 'onboarding', 'blog'],
        defaultNS: 'global',     // namespace par défaut
        fallbackLng: 'fr',       // langue fallback
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
